import { render, staticRenderFns } from "./DataTableMain.vue?vue&type=template&id=57eddac2"
import script from "./DataTableMain.vue?vue&type=script&lang=js"
export * from "./DataTableMain.vue?vue&type=script&lang=js"
import style0 from "./DataTableMain.vue?vue&type=style&index=0&id=57eddac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports